import React, { useState, useEffect } from 'react';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ChevronUp, Download, PlusCircle, RotateCcw } from 'feather-icons-react/build/IconComponents';
import { setToogleHeader, set_page_refresh } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import AddPurchases from '../../core/modals/purchases/addpurchases';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable';
import axios from "axios";
import Select from 'react-select';
import { set_purchase_list, set_purchase_edit } from '../../core/redux/action';
import { dateFormatter } from '../../plugins/helper';

const PurchasesList = () => {
    const dispatch = useDispatch();
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    const data = useSelector((state) => state.toggle_header);
    const pageRefresh = useSelector((state) => (state.pageRefresh?.purchaselist || 0));
    const dataSource = useSelector((state) => state.purchase_list || []);
    const [storeOption, setStoreOption] = useState([]);
    const [selectedStore, setSelectedStore] = useState('');

    useEffect(() => {
        async function fetchData() {
            const storeIds = localStorage.getItem('storeIds');
            let result = await axios.get("getuserpurchases/", {
                params: {
                  storeIds: storeIds, // Add query parameters here
                },
              });
            const storeOptionsList = localStorage.getItem('storeOptionsList');
            if (storeOptionsList) {
                setStoreOption(JSON.parse(storeOptionsList));
            }
            dispatch(set_purchase_list(result.data));
            
        }
        fetchData();
    }, [dispatch, pageRefresh]);

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>Pdf</Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>Excel</Tooltip>
    );
    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>Printer</Tooltip>
    );
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>Refresh</Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>Collapse</Tooltip>
    );
    const MySwal = withReactContent(Swal);
    //Permissions  
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'view');
    const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'create');
    const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'purchases' && p.Permission.toLowerCase() === 'delete');

    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}
    //
    const columns = [
        {
            title: t?.[l]?.["purchase_id"] || "Purchase Id",
            dataIndex: "_id",
        },
        // {
        //     title: t?.[l]?.["added_by"] || "Added by",
        //     dataIndex: "createdBy",
        //     render: (text) => <span>{text.name}</span>,
        // },
        // {
        //     title: t?.[l]?.["store_ids"] || "Store IDs",
        //     dataIndex: "products",
        //     render: (products) => {
        //         if (Array.isArray(products)) {
        //             const uniqueStoreIds = [...new Set(products.map(product => product.storeName))];
        //             return <span>{uniqueStoreIds.join(", ")}</span>;
        //         }
        //         return <span>-</span>;
        //     },
        // },
        {
            title: t?.[l]?.["store_names"] || "Store Names",
            dataIndex: "products",
            render: (products) => {
                if (Array.isArray(products)) {
                    // Extract unique store names and remove the last parentheses
                    const uniqueStoreNames = [
                        ...new Set(
                            products.map(product =>
                                product.storeName.replace(/\s*\([^)]*\)\s*$/, "").trim()
                            )
                        )
                    ];
                    return <span>{uniqueStoreNames.join(", ")}</span>;
                }
                return <span>-</span>;
            },
        },
        
        {
            title: t?.[l]?.["date"] || "Date",
            dataIndex: "createdAt",
            render: (text) => <span>{dateFormatter(text,l)}</span>,
        },
        {
            title: t?.[l]?.["product_count"] || "Product Count",
            dataIndex: "products",
            render: (products) => <span>{products?.length || 0}</span>,
        },
        {
            title: t?.[l]?.["items_count"] || "Items Count",
            dataIndex: "grossCount",
        },
        {
            title: t?.[l]?.["status"] || "Status",
            dataIndex: "purchaseStatus",
            render: (text) => {
                const statusStyle = text === "received"
                    ? { backgroundColor: "#3D8E03", color: "white" }
                    : { backgroundColor: "#EBAC0A", color: "white" };
                return <span className="badge-linesuccess capitalize" style={statusStyle}>
                    {t[l]?.[text.toLowerCase()] }
                    </span>;
            },
        },
        {
            title: t?.[l]?.["action"] || 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                    {canUpdate && (
                        <Link
                            className="me-2 p-2"
                            data-bs-toggle="modal"
                            data-bs-target="#add-units"
                            onClick={() => dispatch(set_purchase_edit(record))}
                        > 
                            <i data-feather="edit" className="feather-edit" />
                        </Link>
                        )}
                    {canDelete && (
                        
                        <Link className="confirm-text p-2" to="#" onClick={(e) => showConfirmationAlert(e,record)}>
                            <i data-feather="trash-2" className="feather-trash-2" />
                        </Link>
                    )}
                    </div>
                </td>
            )
        },
    ];
console.log("Purchase dataSource",dataSource)
    // const filteredDataSource = selectedStore
    //     ? dataSource.filter(purchase => purchase.storeId === selectedStore)
    //     : dataSource;
    const filteredDataSource = selectedStore
    ? dataSource.filter(purchase =>
        purchase.products.some(product => product.storeId === selectedStore)
      )
    : dataSource;

    const showConfirmationAlert = (e,record) => {
        e.preventDefault();
        MySwal.fire({
            title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
            text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.post("removepurchase/", record);
                    dispatch(set_page_refresh("purchaselist"));
                    MySwal.fire({
                        title: t?.[l]?.["deleted!"] || "Deleted!",
                        text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
                        className: "btn btn-success",
                        confirmButtonText: t?.[l]?.["ok"] || "OK",
                        customClass: { confirmButton: "btn btn-success" },
                    });
                } catch (e) {
                    console.log(e);
                }
            } else {
                MySwal.close();
            }
        });
    };

    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <div className="page-header transfer">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>{t?.[l]?.["purchase_list"] || "Purchase List"}</h4>
                                <h6>{t?.[l]?.["manage_your_purchases"] || "Manage your purchases"}</h6>
                            
                            </div>
                        </div>
                        <div className="search-set" style={{marginLeft: "auto"}}>
                        <div className="search-input">
                            <Select
                                className="select"
                                options={storeOption}
                                value={storeOption.find(option => option.value === selectedStore)}
                                onChange={(option) => setSelectedStore(option.value)}
                                placeholder={t[l]?.["all_stores"] || "All Stores"}
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        minWidth: '150px', // Set your desired minimum width here
                                        borderColor: '#e9edf6 !important',
                                        lineHeight: '1.6',
                                        borderRadius: '0.35rem',
                                    }),
                                }}
                            />
                        </div>
                        <div className="search-input">
                    
                        </div>

                    </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => dispatch(setToogleHeader(!data))}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className="d-flex purchase-pg-btn">
                        {canCreate ? (
                            <div className="page-btn">
                                <Link
                                    to="#"
                                    className="btn btn-added"
                                    data-bs-toggle="modal"
                                    data-bs-target="#add-units"
                                    onClick={() => dispatch(set_purchase_edit({}))}
                                >
                                    <PlusCircle className="me-2" />
                                    {t?.[l]?.["add_new_purchase"] || "Add New Purchase"}
                                </Link>
                            </div>
                        ) : null}
                            <div className="page-btn import hidden">
                                <Link
                                    to="#"
                                    className="btn btn-added color"
                                    data-bs-toggle="modal"
                                    data-bs-target="#view-notes"
                                >
                                    <Download className="me-2" />
                                    Import Purchase
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table columns={columns} dataSource={filteredDataSource} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddPurchases />
        </div>
    );
}

export default PurchasesList;
